import { render, staticRenderFns } from "./AddEquipo.vue?vue&type=template&id=5ebd246c&"
import script from "./AddEquipo.vue?vue&type=script&lang=js&"
export * from "./AddEquipo.vue?vue&type=script&lang=js&"
import style0 from "./AddEquipo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports